<form [formGroup]="$form" style="height: 100%;">

  <div style="display: flex; flex-direction: column;justify-content: space-between; height: 100%;">

    <div class="mt16">

      <div
        style   ="border: solid #dedede 1px; padding: 8px; padding-left: 24px; padding-right: 24px; cursor: pointer;" class   ="step-title"
        (click) ="downloadTemplate()">
        <i class="pi pi-file-excel mr16"></i>
        {{'@@GENERATE_EXCEL_REPORT.ACTION.TEMPLATE' | translate}}
      </div>

      <div class="panel mt16">{{'@@GENERATE_EXCEL_REPORT.MESSAGE' | translate }}</div>

      <div class="mt32">
        <p-fileUpload
          #fu
          [style]     = "{'width': '100%'}"
          mode        = "basic"
          chooseLabel = "Upload Excel file"
          chooseIcon  = "pi pi-upload"
          accept      = ".xlsx"
          maxFileSize = "5000000"
          (onSelect)  = "processEmit($event, fu)" />
      </div>
    </div>
  </div>
</form>
